<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2, getScreen } from '../../Reusable/O3DG2'
import { PlaneBufferGeometry, MeshBasicMaterial, Mesh } from 'three'

export default {
  mixins: [O3DG2],
  methods: {
    setup () {
      let mat = new MeshBasicMaterial({ color: 0xff0000 })
      let mesh = new Mesh(undefined, mat)

      this.onResize(() => {
        let screen = getScreen({ camera: this.ctx.camera, depth: this.o3d.position.z })
        let screenHeight = screen.height
        let innerHeight = window.innerHeight
        let px = screenHeight / innerHeight
        let geo = new PlaneBufferGeometry(screen.width, 1 * px, 2, 2)
        mesh.geometry = geo
      })
      this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>